import { Pipe, PipeTransform } from '@angular/core';
import { getAvatarUrl } from './user.functions';

@Pipe({
  name: 'avatarUrl'
})
export class UserAvatarUrlPipe implements PipeTransform {
    transform(inputValue?: any): string {
        return getAvatarUrl(inputValue);
    }
};